import { Slider } from 'antd';
import styled from 'styled-components';

export default styled(Slider)`
	// Add your styles here
`;
